import { z } from 'zod';

export const placeImportFromGmapsRequest = z.object({
  url: z.string().min(1).max(2000),
});
export type PlaceImportFromGmapsRequest = z.infer<typeof placeImportFromGmapsRequest>;

export const placeImportFromGmapsResponse = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('existing'),
    placeId: z.uuid(),
  }),
  z.object({
    kind: z.literal('prefill'),
    googlePlaceId: z.string(),
    name: z.string(),
    address: z.string(),
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    websiteUrl: z.string().nullable(),
    cityId: z.uuid().nullable(),
    categoryIds: z.array(z.uuid()).default([]),
    coverStorageKey: z.string().nullable(),
    coverPreviewUrl: z.string().nullable(),
  }),
]);
export type PlaceImportFromGmapsResponse = z.infer<typeof placeImportFromGmapsResponse>;
